import React, {useState, useEffect, useRef, useContext} from 'react'
import '../Products.css'
import {
  getRainwaterCategories,
  getRainwaterParts,
  getRainwaterStyles,
  getRainwaterUnitTypes,
  getRainwaterMasterlist,
  createRainwaterProduct,
  updateRainwaterProduct,
  deleteRainwaterProduct,
} from '../../../../../api/rainwater-api'
import {getColours} from '../../../../../api/index'
import {AdminProductContext} from '../../../../../context/AdminProductContext'
import {useAsyncFn, useEffectOnce} from 'react-use'
import RainwaterProduct from './RainwaterProduct'
import AddProductButton from '../../../../../../_metronic/partials/content/button/AddProductButton'
import NewProductModal from '../../../../../../_metronic/partials/modals/NewProductModal'
import DeleteModal from '../../../../../../_metronic/partials/modals/DeleteModal'
import {useHistory} from 'react-router-dom'

type Props = {
  product: string
  productId: number
}

const Rainwater = (props: Props) => {
  const {
    rainwaterCategories,
    setRainwaterCategories,
    rainwaterParts,
    setRainwaterParts,
    rainwaterStyles,
    setRainwaterStyles,
    rainwaterUnitTypes,
    setRainwaterUnitTypes,
    colours,
    setColours,
  } = useContext(AdminProductContext)

  const {productId} = props
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)
  const [isSeqAdding, setIsSeqAdding] = useState(false)
  const [isAddingProduct, setIsAddingProduct] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const baseURL = process.env.REACT_APP_API_URL

  const [Filter1, setFilter1] = useState('')
  const [Filter2, setFilter2] = useState('')
  const [Filter3, setFilter3] = useState('')

  const history = useHistory()

  /**REFS */
  const styleRef = useRef<any>()
  const partNameRef = useRef<any>()
  const unitRef = useRef<any>()
  const priceRef = useRef<any>()
  const regex = /^[a-zA-Z0-9\s./-]*$/
  const numRegex = /^[A-Za-z0-9\s.]*$/

  /**
   * SEQ
   */
  const [seqData, setSeqData] = useState<any>({})
  const [newSeqProduct, setNewSeqProduct] = useState({})
  const [seqCurrentPage, setSeqCurrentPage] = useState(1)
  const [seqTotalPages, setSeqTotalPages] = useState(1)
  const [seqDataPerPage] = useState(10)
  const [editingSeqId, setEditingSeqId] = useState(null)
  const [editedSeqData, setEditedSeqData] = useState({})

  /**
   * INITIAL SETUP
   */
  useEffectOnce(() => {
    if (!rainwaterCategories && !fetchRainwaterCategories) {
      getRainwaterCategoriesAsync()
    }
    if (!rainwaterParts && !fetchRainwaterParts) {
      getRainwaterPartsAsync()
    }
    if (!rainwaterStyles && !fetchRainwaterStyles) {
      getRainwaterStylesAsync()
    }
    if (!rainwaterUnitTypes && !fetchRainwaterUnitTypes) {
      getRainwaterUnitTypesAsync()
    }
    if (!fetchColours && !colours) {
      fetchColoursAsync()
    }
  })

  /**
   * FETCH RECORD
   */
  const [{loading: fetchRainwaterCategories}, getRainwaterCategoriesAsync] =
    useAsyncFn(async () => {
      const result: any = await getRainwaterCategories()
      if (result != null) {
        setRainwaterCategories(result.data)
      }
    }, [setRainwaterCategories])

  const [{loading: fetchRainwaterParts}, getRainwaterPartsAsync] = useAsyncFn(async () => {
    const result: any = await getRainwaterParts()
    if (result != null) {
      setRainwaterParts(result.data)
    }
  }, [setRainwaterParts])

  const [{loading: fetchRainwaterStyles}, getRainwaterStylesAsync] = useAsyncFn(async () => {
    const result: any = await getRainwaterStyles()
    if (result != null) {
      setRainwaterStyles(result.data)
    }
  }, [setRainwaterStyles])

  const [{loading: fetchRainwaterUnitTypes}, getRainwaterUnitTypesAsync] = useAsyncFn(async () => {
    const result: any = await getRainwaterUnitTypes()
    if (result != null) {
      setRainwaterUnitTypes(result.data)
    }
  }, [setRainwaterStyles])

  const [{loading: fetchColours}, fetchColoursAsync] = useAsyncFn(async () => {
    const result: any = await getColours()
    if (result != null) {
      setColours(result.data)
    }
  }, [setColours])

  /**
   * Pricebook Event
   */
  useEffect(() => {
    setSeqTotalPages(1)
    setSeqCurrentPage(1)
    // fetchRainwaterProduct(1)
  }, [productId])

  const fetchRainwaterProduct = async (
    currentPage: number,
    filter1?: any,
    filter2?: any,
    filter3?: any
  ) => {
    await getRainwaterMasterlist(currentPage, seqDataPerPage, filter1, filter2, filter3).then(
      (response: any) => {
        setSeqData(response.data)
        setSeqTotalPages(Math.ceil(response.data?.totalCount / 10))
      }
    )
  }

  /**
   * PAGINATION
   */
  const handleFilter = (filter1: any, filter2: any, filter3: any) => {
    setFilter1(filter1)
    setFilter2(filter2)
    setFilter3(filter3)
    setSeqCurrentPage(1)
  }

  // useEffect(() => {
  //   // fetchRainwatersProduct(seqCurrentPage, Filter1, Filter2)
  //   setSeqCurrentPage(1)
  // }, [Filter1, Filter2, Filter3])

  useEffect(() => {
    fetchRainwaterProduct(seqCurrentPage, Filter1, Filter2, Filter3)
  }, [seqCurrentPage, Filter1, Filter2, Filter3])

  const handlePrevPage = () => {
    setSeqCurrentPage((prevPage: number) => prevPage - 1)
  }
  const handleNextPage = () => {
    setSeqCurrentPage((prevPage: number) => prevPage + 1)
  }

  const handleCancelClick = () => {
    setErrorMsg(undefined)
    setSuccessMsg(undefined)
    setIsSeqAdding(false)
  }
  const handleCancel = () => {
    setErrorMsg(undefined)
    setSuccessMsg(undefined)
    setEditingSeqId(null)
    setEditedSeqData({})
  }
  const handleChange = (e: any) => {
    const {name, value} = e.target
    if (parseInt(value) < 0 || parseFloat(value) < 0) {
      return
    }

    if (regex.test(value)) {
      setEditedSeqData((prevData: any) => ({
        ...prevData,
        [name]: name === 'panelThickness' ? {...name, name: value} : value,
      }))
    }
  }
  /**
   * DELETE
   */
  const handleDeleteProduct = (id: any) => {
    setItemToDelete(id)
    setIsModalOpen(true)
  }
  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true)
      const result: any = await deleteRainwaterProduct(itemToDelete || 0)
      if (result.data == '' || result.data) {
        await fetchRainwaterProduct(seqCurrentPage)
        handleSuccessMsg('Product deleted successfully.')
      } else {
        const errorMessage =
          result.error?.message || 'Error Encountered While Deleting. Please try again later.'
        handleErrorMessage(errorMessage)
      }
    } catch (error) {
      console.error('Error deleting Rainwater:', error)
      handleErrorMessage('Error Encountered While Deleting. Please try again later.')
    }

    setIsModalOpen(false)
    setItemToDelete(null)
    setIsDeleting(false)
  }
  const handleCancelDelete = () => {
    setItemToDelete(null)
    setIsModalOpen(false)
  }
  /**
   * UPDATE
   */
  const handleUpdateSuccess = (newItem: any) => {
    if (!isSeqAdding) {
      const newData = {
        ...seqData,
        items: seqData.items?.map((item: any) => (item.id === editingSeqId ? newItem : item)),
      }
      setSeqData(newData)
    } else {
      seqData.items.unshift(newItem)
      setSeqData(seqData)
    }
    handleSuccessMsg('Product updated sucessfully.')
    setEditingSeqId(null)
    setEditedSeqData({})
    setNewSeqProduct({})
    setIsSeqAdding(false)
  }

  const handleUpdateProduct = (iProductId: any) => {
    history.push(`/admin/product-details/Rainwater/${iProductId}`)
  }

  const handleSave = () => {
    const newData = {
      ...seqData,
      items: seqData.items?.map((item: any) => (item.id === editingSeqId ? editedSeqData : item)),
    }
    setSeqData(newData)
    setEditingSeqId(null)
    setEditedSeqData({})
  }
  /**
   * ADD
   */

  const handleAddProduct = () => {
    setIsAddingProduct(true)
  }
  const handleSaveClick = () => {
    setSeqData({...seqData, items: [newSeqProduct, ...seqData.items]})
    setIsSeqAdding(false)
  }
  const handleInputChange = (e: any) => {
    const {name, value} = e.target
    if (!numRegex.test(priceRef.current.value)) {
      priceRef.current.value = value.replace(/[^a-zA-Z]/g, '')
      return
    }
    if (!regex.test(styleRef.current.value)) {
      styleRef.current.value = value.replace(/[^a-zA-Z]/g, '')
      return
    }
    if (!regex.test(partNameRef.current.value)) {
      partNameRef.current.value = value.replace(/[^a-zA-Z]/g, '')
      return
    }
    if (!regex.test(unitRef.current.value)) {
      unitRef.current.value = value.replace(/[^a-zA-Z]/g, '')
      return
    }

    setNewSeqProduct({...newSeqProduct, [name]: value})
  }

  /**
   * ALERT MESSAGE
   */
  const [errorMsg, setErrorMsg] = useState<string | undefined>()
  const handleErrorMessage = (errorMsg: string) => {
    setErrorMsg(errorMsg)
    setSuccessMsg(undefined)
  }

  const [successMsg, setSuccessMsg] = useState<string | undefined>()
  const handleSuccessMsg = (successMsg: string) => {
    setSuccessMsg(successMsg)
    setErrorMsg(undefined)
  }

  const productFields = [
    {label: 'Item Number', key: 'Code', type: 'text'},
    {label: 'Product Name', key: 'RainwaterStyleName', type: 'text'},
    {label: 'Category Name', key: 'RainwaterPartName', type: 'text'},
    {label: 'Colour', key: 'RainwaterColourId', type: 'dropdown', options: colours},
  ]

  const handleCloseNewProductModal = () => {
    setIsAddingProduct(false)
  }

  const handleSaveNewProduct = async (newProduct: any) => {
    createRainwaterProduct(newProduct)
      .then((result: any) => {
        if (result.data) {
          handleSuccessMsg('Product added successfully.')
          fetchRainwaterProduct(seqCurrentPage)
        } else {
          handleErrorMessage(result?.response?.data)
        }
      })
      .catch(() => {
        handleErrorMessage('Error Encountered While Saving. Please try again later.')
      })

    setIsSeqAdding(false)
  }

  return (
    <>
      <div className='card-body' style={{height: '100vh', backgroundColor: '#fff'}}>
        <AddProductButton onClick={handleAddProduct} />
        <div style={{overflowY: 'auto', height: '95%'}}>
          {errorMsg && (
            <div className='alert alert-danger w-50 m-auto text-center' role='alert'>
              <i className='fa fa-exclamation-circle text-danger'></i> {errorMsg}
            </div>
          )}
          {successMsg && (
            <div className='alert alert-success w-50 m-auto text-center' role='alert'>
              <i className='fa fa-check-circle text-success'></i> {successMsg}
            </div>
          )}

          <RainwaterProduct
            data={seqData}
            currentPage={seqCurrentPage}
            totalPages={seqTotalPages}
            handleUpdateProduct={handleUpdateProduct}
            handleSave={handleSave}
            editingId={editingSeqId}
            editedData={editedSeqData}
            handleSaveClick={handleSaveClick}
            handleInputChange={handleInputChange}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            handleCancelClick={handleCancelClick}
            handleCancel={handleCancel}
            handleDeleteProduct={handleDeleteProduct}
            handleChange={handleChange}
            isAdding={isSeqAdding}
            styleRef={styleRef}
            partNameRef={partNameRef}
            unitRef={unitRef}
            priceRef={priceRef}
            newProduct={newSeqProduct}
            handleUpdateSuccess={handleUpdateSuccess}
            handleErrorMessage={handleErrorMessage}
            handleFilter={handleFilter}
          />
        </div>
      </div>
      <DeleteModal
        isModalOpen={isModalOpen}
        handleConfirmDelete={handleConfirmDelete}
        handleCancelDelete={handleCancelDelete}
        isDeleting={isDeleting}
      />
      <NewProductModal
        isOpen={isAddingProduct}
        onClose={handleCloseNewProductModal}
        onSave={handleSaveNewProduct}
        fields={productFields}
      />
    </>
  )
}

export default Rainwater
